import React, { useState } from "react";
import "./ViewAllCategories.css";

const ViewAllCategories = ({ tree ,onSelect }) => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [open, setOpen] = useState(false);

  return (
    <div className="view-all-categories">
      <div
        className={`dropdown ${open ? "show" : ""}`}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <div className="btn btn-dark mt-1 dropdown-toggle">
          View all categories
        </div>

        <div className={`dropdown-menu mega-menu p-0 ${open ? "show" : ""}`}>
          <div className="d-flex">
            {/* ستون چپ: دسته اصلی */}
            <div className="category-list">
              {tree.map((cat) => (
                <div
                  key={cat._id}
                  onClick={() => onSelect?.(cat)}
                  className={`category-item ${
                    activeCategory?._id === cat._id ? "active" : ""
                  }`}
                  onMouseEnter={() => setActiveCategory(cat)}
                >
                  {cat.name}
                </div>
              ))}
            </div>

            {/* ستون راست: زیرشاخه‌ها */}
            <div className="subcategory-panel">
              {activeCategory && activeCategory.children?.length > 0 ? (
                <div className="row p-3">
                  {activeCategory.children.map((sub, idx) => (
                    <div className="col-md-4" key={idx} onClick={() => onSelect?.(sub)}>
                      <h6 className="fw-bold">{sub.name}</h6>
                      {sub.children?.length > 0 && (
                        <ul className="list-unstyled">
                          {sub.children.map((child) => (
                            <li key={child._id}>
                              <a href={`/category/${child._id}`}>{child.name}</a>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="p-3 text-muted">No subcategories</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAllCategories;
